import React, { useCallback, useEffect, useState } from 'react';
import Globali18n from 'i18n-js';
import { translations } from 'assets/translations';
import { useStore } from 'hooks/useStore';
Globali18n.translations = translations;
Globali18n.defaultLocale = 'nl';
Globali18n.locale = 'nl';
// noinspection JSUnusedLocalSymbols
/**
 * Default value for Locale context
 */
export const LocaleContext = React.createContext({
    I18n: Globali18n,
    changeLocale: (_) => { },
    translation: (_) => '',
});
const convertMarkUpToHTML = (text) => {
    const markUpValues = ['bold', 'white', 'green', 'yellow', 'blue', 'underline', 'link'];
    const markUpCloseRegex = new RegExp('\\[/.*?]', 'gm');
    let convertedText = text.includes('[/link]')
        ? text.replace(markUpCloseRegex, '</a>')
        : text.replace(markUpCloseRegex, '</span>');
    markUpValues.forEach((value) => {
        if (value === 'link') {
            const markUpOpenRegex = new RegExp(`\\[${value}(?=)`, 'm');
            const links = convertedText.match(RegExp('=.*?]', 'gm'));
            links &&
                links.forEach((link) => {
                    convertedText = convertedText
                        .replace(link, '')
                        .replace(markUpOpenRegex, `<a href="${link.slice(1, -1)}" target="_blank">`);
                });
        }
        else {
            const markUpOpenRegex = new RegExp(`\\[${value}\\]`, 'gm');
            convertedText = convertedText.replace(markUpOpenRegex, `<span class="${value}">`);
        }
    });
    return convertedText;
};
const LocaleProvider = ({ children }) => {
    // spread global value to change ref and force update
    const [I18n, setI18n] = useState(Object.assign({}, Globali18n));
    const store = useStore();
    const changeLocale = useCallback((newLocale) => {
        const translation = translations[newLocale];
        Globali18n.translations = { [newLocale]: translation };
        Globali18n.locale = newLocale;
        // spread global value to change ref and force update
        setI18n(Object.assign({}, Globali18n));
        if (newLocale !== store.locale) {
            store.setStore({ locale: newLocale });
        }
    }, [store]);
    const translation = useCallback((scope, options) => {
        const i18 = I18n.t(scope, Object.assign(Object.assign({}, options), { interpolation: { escapeValue: false } }));
        const text = convertMarkUpToHTML(i18);
        if (!text) {
            return `${scope} not found`;
        }
        return React.createElement("span", { dangerouslySetInnerHTML: { __html: text } });
    }, [I18n]);
    useEffect(() => {
        // set default locale
        if (store.locale) {
            changeLocale(store.locale);
        }
        else {
            changeLocale('nl');
        }
    }, [changeLocale, store]);
    return (React.createElement(LocaleContext.Provider, { value: {
            I18n,
            changeLocale,
            translation,
        } }, children));
};
export default LocaleProvider;
